import styled from '@emotion/styled'

import { Label } from 'shared/ui'

const StyledLabel = styled(Label)`
  overflow: hidden;
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export default function LinkedTrelloCardTitle({ children }) {
  return <StyledLabel size="small">{children}</StyledLabel>
}
